class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {		
    var windowWidth = $(window).width();
    var windowSm = 768;
		if (windowWidth <= windowSm) {
			$('.js-h-content a').on('click', function() {
				$('html').removeClass('is-open');
				scrollBan();
			});
		} else {
			$('.js-mega-trigger').hover(function() {
				$(this).addClass('is-active');
				$(this).next('.js-mega-content').addClass('is-active');
			}, function() {
				$(this).removeClass('is-active'); 
				$(this).next('.js-mega-content').removeClass('is-active');
			});
		
			$('.js-mega-content').hover(function() {
				$(this).addClass('is-active');
				$(this).closest('.js-mega-trigger').addClass('is-active');
				$(this).closest('.js-mega-trigger').find('.js-mega-trigger-plus').addClass('is-active');
			}, function() {
				$(this).removeClass('is-active');
				$(this).closest('.js-mega-trigger').removeClass('is-active');
				$(this).closest('.js-mega-trigger').find('.js-mega-trigger-plus').removeClass('is-active');
			});
		}
    
    $(window).scroll(function () {
      if (!$('html').hasClass('is-top')) {
        return;
      }
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    // スマホメニュー内のクリック（言語切替はそのまま遷移）
    $('.js-header').find('a').not('.c-header-lang__item').click(function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    $('.c-header-lang__item').on('click', function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    let scrollTop = 0;

    // html固定スクロール禁止/解除（引数なし=toggle / true=lock / false=unlock）
    const scrollBan = (() => {
      const html = document.documentElement; // $('html')[0] と同じ
      let locked = false;
      let scrollTop = 0;

      const lock = () => {
        if (locked) return;
        locked = true;

        scrollTop = window.scrollY || 0;

        // 現在位置を固定
        html.style.top = `${-scrollTop}px`;
        html.classList.add("is-hidden");
      };

      const unlock = () => {
        if (!locked && !html.classList.contains("is-hidden")) return;
        locked = false;

        // scroll-behavior を一時的に auto にして瞬間復帰
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";

        html.style.top = "";
        html.classList.remove("is-hidden");

        window.scrollTo(0, scrollTop);

        // 次フレームで元に戻す（0ms setTimeout より安全）
        requestAnimationFrame(() => {
          html.style.scrollBehavior = prevScrollBehavior;
        });
      };

      // state: true=lock / false=unlock / undefined=toggle
      return (state) => {
        if (typeof state === "boolean") {
          state ? lock() : unlock();
          return locked;
        }
        locked ? unlock() : lock();
        return locked;
      };
    })();
  }
}